import React from "react";
const IconMadeInIT = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" {...props}>
    <path
      d="M25 25.957h3.6l3.6 8.022M25 25.957c-6.6 0-15 3.128-15 4.608m15-4.608s-.993-2.655-2.18-5.85M35.8 42l-3.6-8.021m-1.532-3.413H35.8v-4.609c5.4 0 10.2 2.468 10.2 2.468V42H28.6M10 30.566V19.787S13.5 14.5 20.5 13.5c.764 2.096 1.445 4.248 2.32 6.607M10 30.566v5.88m12.82-16.34c-3.82 0-6.656 1.04-9.82 2.356m19.2 11.517c-3.302 0-6.414.129-9.237.346M10 36.447V42h12.963M10 36.447c2.435-.835 7.065-1.67 12.963-2.122m0 0V29.66m0 12.34v-4.75m0 4.75H28.6m0 0v-4.75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconMadeInIT;
